import React from "react";
import { useTranslation } from "react-i18next";

function UzTravellCoach() {
  return (
    <svg viewBox="0 0 900 430" className="h-auto w-full" role="presentation">
      <defs>
        <linearGradient id="coachBody" x1="0" x2="0" y1="0" y2="1">
          <stop offset="0" stopColor="#2188F5" />
          <stop offset="1" stopColor="#0752BD" />
        </linearGradient>
        <linearGradient id="coachGlass" x1="0" x2="1" y1="0" y2="1">
          <stop offset="0" stopColor="#BDEFFF" />
          <stop offset="1" stopColor="#62BDEB" />
        </linearGradient>
      </defs>
      <ellipse cx="447" cy="367" rx="345" ry="26" fill="#17324A" opacity=".12" />

      <path d="M92 148c7-50 31-77 77-77h426c43 0 70 15 96 53l71 102c10 14 15 29 15 47v40c0 26-19 44-45 44H125c-27 0-43-18-43-44V174c0-11 3-19 10-26Z" fill="#10234B" stroke="#10234B" strokeWidth="12" strokeLinejoin="round" />
      <path d="M91 172c5-49 29-78 77-78h419c36 0 60 13 83 46l23 33H91Z" fill="#0A1838" />
      <path d="M108 179h571l59 79H108Z" fill="url(#coachBody)" />

      <path d="M132 111c8-19 19-28 39-28h65v80H116l16-52Z" fill="url(#coachGlass)" stroke="#10234B" strokeWidth="8" />
      <path d="M246 83h91v80h-91z" fill="url(#coachGlass)" stroke="#10234B" strokeWidth="8" />
      <path d="M343 83h91v80h-91z" fill="url(#coachGlass)" stroke="#10234B" strokeWidth="8" />
      <path d="M440 83h91v80h-91z" fill="url(#coachGlass)" stroke="#10234B" strokeWidth="8" />
      <path d="M537 84h45c27 0 47 10 64 33l33 46H537V84Z" fill="url(#coachGlass)" stroke="#10234B" strokeWidth="8" />

      <path d="M126 180h498v70H126z" fill="#075CCB" opacity=".72" />
      <path d="M111 263c91-27 168-30 245-6 81 25 161 38 278 24l80-10v47H119c-18 0-30-11-30-28v-13l22-14Z" fill="#FFC21C" />
      <path d="M107 284c99-11 161-3 242 23 86 28 201 35 340 13v18H125c-19 0-31-12-31-30v-10l13-14Z" fill="#0E73E8" />

      <path d="M624 83h12c25 0 45 9 61 31l76 103c8 11 12 23 12 37v43c0 17-11 30-28 33l-67 11 3-155-69-96Z" fill="#0A1838" stroke="#10234B" strokeWidth="8" strokeLinejoin="round" />
      <path d="M641 99c19 2 31 10 45 28l72 99c6 8 9 17 9 27v7c-57-3-98-16-136-39l-39-26V103l49-4Z" fill="url(#coachGlass)" stroke="#10234B" strokeWidth="8" strokeLinejoin="round" />
      <path d="M632 211c43 29 88 43 135 47v28c-46-2-93-14-137-37l-29-15v-37l31 14Z" fill="#10234B" />
      <path d="M684 298c29-7 55-13 83-15v19c0 17-11 30-28 33l-54 9-1-46Z" fill="#10234B" />

      <path d="M587 91v222" stroke="#F6FAFF" strokeWidth="9" opacity=".94" />
      <path d="M594 94v214" stroke="#FFC21C" strokeWidth="4" />
      <path d="M641 318h71" stroke="#F6FAFF" strokeWidth="7" opacity=".8" />
      <text x="282" y="236" fill="#F8FAFC" fontSize="26" fontWeight="800" letterSpacing="1.2">UzTravell</text>
      <path d="M768 238h20c9 0 16 7 16 16v9h-31l-5-25Z" fill="#10234B" />
      <path d="M774 309h20v10h-18z" fill="#FFD85A" />

      <g fill="#112443" stroke="#F2F7FC" strokeWidth="10">
        <circle cx="225" cy="326" r="48" />
        <circle cx="530" cy="326" r="48" />
        <circle cx="225" cy="326" r="18" fill="#AFC6D7" strokeWidth="6" />
        <circle cx="530" cy="326" r="18" fill="#AFC6D7" strokeWidth="6" />
      </g>
      <path d="M103 357h650" stroke="#D6E2EA" strokeWidth="4" strokeDasharray="13 15" strokeLinecap="round" />
      <path d="M750 357h55" stroke="#FFC21C" strokeWidth="5" strokeDasharray="7 9" strokeLinecap="round" />
    </svg>
  );
}

export default function BusLoading({ compact = false, className = "", title, subtitle, date }) {
  const { t } = useTranslation();

  return (
    <div
      role="status"
      aria-live="polite"
      className={`flex w-full flex-col items-center text-center ${compact ? "min-h-44 justify-center gap-2 py-5" : "min-h-svh justify-between px-5 pt-8 pb-[14vh] sm:pt-10"} ${className}`}
    >
      {!compact && date ? <p className="pt-1 text-xl font-semibold tracking-tight text-slate-700 dark:text-slate-300 sm:text-2xl">{date}</p> : <span aria-hidden="true" />}
      <div aria-hidden="true" className={`bus-loader-brand-mark flex w-full items-center justify-center ${compact ? "max-w-[300px]" : "max-w-[740px] py-5"}`}>
        <UzTravellCoach />
      </div>
      <div className="px-4 pb-2">
        <p className={`font-bold text-slate-800 dark:text-slate-100 ${compact ? "text-sm" : "text-xl sm:text-[30px]"}`}>{title || t("loading.title")}</p>
        <p className={`mt-1 text-slate-500 dark:text-slate-400 ${compact ? "text-xs" : "text-lg sm:text-2xl"}`}>{subtitle || t("loading.subtitle")}</p>
      </div>
    </div>
  );
}
